import { useState, useEffect, useCallback } from "react";
import { T } from "../../theme";
import { apiCall } from "../../apiClient";
import { Btn, Inp, Modal } from "../primitives";

export const CompanyEntitiesManager = () => {
  const [entities, setEntities] = useState<any[]>([]);
  const [showAdd, setShowAdd] = useState(false);
  const [editEntity, setEditEntity] = useState<any>(null);
  const [form, setForm] = useState({ name: "", is_default: false, is_active: true, sort_order: 0 });

  const load = useCallback(async () => {
    const r = await apiCall("/company-entities");
    if (r?.entities) setEntities(r.entities);
  }, []);

  useEffect(() => { void load(); }, [load]);

  const handleSave = async () => {
    if (!form.name.trim()) return;
    if (editEntity) {
      await apiCall("/company-entities/" + editEntity.id, { method: "PUT", body: JSON.stringify(form) });
    } else {
      await apiCall("/company-entities", { method: "POST", body: JSON.stringify(form) });
    }
    setShowAdd(false); setEditEntity(null); setForm({ name: "", is_default: false, is_active: true, sort_order: 0 });
    void load();
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm("Deactivate this entity?")) return;
    await apiCall("/company-entities/" + id, { method: "DELETE" });
    void load();
  };

  const handleSetDefault = async (id: string) => {
    await apiCall("/company-entities/" + id, { method: "PUT", body: JSON.stringify({ is_default: true }) });
    void load();
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 700 }}>Company Entities</div>
        <Btn v="primary" sz="sm" onClick={() => { setForm({ name: "", is_default: false, is_active: true, sort_order: 0 }); setEditEntity(null); setShowAdd(true); }}>Add Entity</Btn>
      </div>
      <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
        <thead><tr style={{ borderBottom: "2px solid " + T.brd }}>
          <th style={{ textAlign: "left", padding: 8 }}>Name</th>
          <th style={{ textAlign: "center", padding: 8 }}>Default</th>
          <th style={{ textAlign: "center", padding: 8 }}>Active</th>
          <th style={{ textAlign: "center", padding: 8 }}>Sort</th>
          <th style={{ textAlign: "right", padding: 8 }}>Actions</th>
        </tr></thead>
        <tbody>
          {entities.map(e => (
            <tr key={e.id} style={{ borderBottom: "1px solid " + T.brd }}>
              <td style={{ padding: 8 }}>{e.name}</td>
              <td style={{ padding: 8, textAlign: "center" }}>{e.is_default ? "\u2713" : ""}</td>
              <td style={{ padding: 8, textAlign: "center" }}>{e.is_active ? "\u2713" : "\u2717"}</td>
              <td style={{ padding: 8, textAlign: "center" }}>{e.sort_order}</td>
              <td style={{ padding: 8, textAlign: "right" }}>
                <span onClick={() => { setEditEntity(e); setForm({ name: e.name, is_default: e.is_default, is_active: e.is_active, sort_order: e.sort_order }); setShowAdd(true); }} style={{ color: T.acc, cursor: "pointer", marginRight: 12, fontSize: 11 }}>Edit</span>
                {!e.is_default && <span onClick={() => { void handleSetDefault(e.id); }} style={{ color: T.blu, cursor: "pointer", marginRight: 12, fontSize: 11 }}>Set Default</span>}
                {!e.is_default && <span onClick={() => { void handleDelete(e.id); }} style={{ color: T.red, cursor: "pointer", fontSize: 11 }}>Deactivate</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showAdd && (
        <Modal open onClose={() => { setShowAdd(false); setEditEntity(null); }} title={editEntity ? "Edit Entity" : "Add Entity"}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Inp label="Name" value={form.name} onChange={(v: string) => setForm(p => ({ ...p, name: v }))} placeholder="e.g., Erlichman Law, PLLC" />
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input type="checkbox" checked={form.is_default} onChange={e => setForm(p => ({ ...p, is_default: e.target.checked }))} />
              <span style={{ fontSize: 12 }}>Default entity</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input type="checkbox" checked={form.is_active} onChange={e => setForm(p => ({ ...p, is_active: e.target.checked }))} />
              <span style={{ fontSize: 12 }}>Active</span>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
              <Btn v="secondary" onClick={() => { setShowAdd(false); setEditEntity(null); }}>Cancel</Btn>
              <Btn v="primary" onClick={() => { void handleSave(); }}>{editEntity ? "Update" : "Create"}</Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
